import React, { useState, useEffect } from 'react';

const MemoryGame = () => {
  // Képek és azok nevei
  const cardImages = [
    { name: 'Macska', image: "/wp-content/uploads/MemoryGame/img/a.jpg" },
    { name: 'Kutya', image: "/wp-content/uploads/MemoryGame/img/b.jpg" },
    { name: 'Róka', image: "/wp-content/uploads/MemoryGame/img/c.jpg" },
    { name: 'Oroszlán', image: "/wp-content/uploads/MemoryGame/img/d.jpg" },
    { name: 'Tigris', image: "/wp-content/uploads/MemoryGame/img/e.jpg" },
    { name: 'Ló', image: "/wp-content/uploads/MemoryGame/img/f.jpg" },
    { name: 'Zsiráf', image: "/wp-content/uploads/MemoryGame/img/g.jpeg" },
    { name: 'Elefánt', image: "/wp-content/uploads/MemoryGame/img/h.jpg" },
  ];

  // Játék állapotai
  const [cards, setCards] = useState([]);
  const [flipped, setFlipped] = useState([]);
  const [matched, setMatched] = useState([]);
  const [score, setScore] = useState(0);
  const [gameOver, setGameOver] = useState(false);

  // Játék inicializálása
  const initializeGame = () => {
    // Duplikáljuk a képeket és összekeverjük
    const shuffledCards = [...cardImages, ...cardImages]
      .sort(() => Math.random() - 0.5)
      .map((card, index) => ({ ...card, id: index }));

    setCards(shuffledCards);
    setFlipped([]);
    setMatched([]);
    setScore(0);
    setGameOver(false);
  };

  // Kártya kattintás kezelése
  const handleCardClick = (id) => {
    // Ne legyen túl érzékeny a kattintásra
    if (flipped.length === 2 || flipped.includes(id) || matched.includes(id)) {
      return;
    }

    const newFlipped = [...flipped, id];
    setFlipped(newFlipped);

    // Ha két kártya van felfordítva
    if (newFlipped.length === 2) {
      const [firstId, secondId] = newFlipped;
      const firstCard = cards.find(card => card.id === firstId);
      const secondCard = cards.find(card => card.id === secondId);

      // Ha egyeznek
      if (firstCard.name === secondCard.name) {
        setMatched([...matched, firstId, secondId]);
        setScore(score + 1);
        setFlipped([]);
      } else {
        // Ha nem egyeznek, várjunk egy kicsit és fordítsuk vissza
        setTimeout(() => {
          setFlipped([]);
        }, 1000);
      }
    }
  };

  // Játék vége ellenőrzése
  useEffect(() => {
    if (matched.length > 0 && matched.length === cards.length) {
      setGameOver(true);
    }
  }, [matched, cards.length]);

  // Játék indítása komponens mountolásakor
  useEffect(() => {
    initializeGame();
  }, []);

  return (
    <div className="memory-game">
      <h3>Memóriajáték</h3>
      <p>Pontszám: {score}</p>
      
      <div className="board">
        {cards.map((card) => (
          <div
            key={card.id}
            className={`card ${
              flipped.includes(card.id) || matched.includes(card.id) ? 'flipped' : ''
            }`}
            onClick={() => handleCardClick(card.id)}
          >
            <div className="card-back">🃏</div>
            <div className="card-front">
            <img src={card.image} alt={card.name  } />
              {flipped.includes(card.id) && !matched.includes(card.id) && (
                <div className="card-name"><img src={card.image} alt={card.name} /></div>
              )}
            </div>
          </div>
        ))}
      </div>

      {gameOver && (
        <div className="modal">
          <div className="modal-content">
            <h4>Gratulálok!</h4>
            <p>Végső pontszám: {score}</p>
            <button onClick={initializeGame}>Új játék</button>
          </div>
        </div>
      )}

      <style jsx>{`
        .memory-game {
          max-width: 600px;
          margin: 0 auto;
          text-align: center;
          font-family: Arial, sans-serif;
        }
        
        .board {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 10px;
          margin-top: 20px;
        }
        
        .card {
          aspect-ratio: 1;
          perspective: 1000px;
          cursor: pointer;
        }
        
        .card img {
          width: 90%;
          height: 90%;
          object-fit: cover; /* Képek arányos kitöltése */
        }
        .card div {
          position: absolute;
          width: 100%;
          height: 100%;
          backface-visibility: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 40px;
          border-radius: 8px;
          transition: transform 0.5s;
          background: white;
          box-shadow: 0 2px 5px hsla(0, 0.00%, 0.00%, 0.20);
        }
        
        .card-back {
          background: #B8C4A0 !important;
          color: white;
        }
        
        .card-front {
          transform: rotateY(180deg);
        }
        
        .flipped .card-back {
          transform: rotateY(180deg);
        }
        
        .flipped .card-front {
          transform: rotateY(0deg);
        }
        
        .card-name {
          position: absolute;
          bottom: 5px;
          font-size: 12px;
          color: #333;
        }
        
        .modal {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0,0,0,0.5);
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .modal-content {
          background: white;
          padding: 20px;
          border-radius: 8px;
          text-align: center;
        }
        
        .modal button {
          margin-top: 15px;
          padding: 8px 16px;
          background: #B8C4A0;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        }
      `}</style>
    </div>
  );
};

export default MemoryGame;